import {useState} from "react";
import {DndSortable} from "../../system/components/dnd-sortable";

export default function Index() {
    const [cols, setCols] = useState( [
        {
            label: "Todo",
            id: 1,
            className: "col col-todo w-full",
            footer: <button>+ Add</button>,
            draggable: true, // ✅ ستون قابل درگ
            items: [
                {
                    label: "Item A",
                    id: 11,
                    draggable: true, // ✅ آیتم قابل درگ

                    template: (data) => (
                        <div style={{ padding: 10, borderRadius: 8, border: "1px solid #000" }}>
                            ✅ {data.label}
                        </div>
                    ),
                },
                { label: "Item B", id: 12, draggable: false }, // ❌ این آیتم قفل
            ],
        },
        {
            label: "Doing",
            id: 2,
            draggable: false, // ❌ این ستون قفل (ولی آیتم‌ها هنوز می‌تونن درگ بشن، اگر global items روشن باشه)
            footer: <div style={{ opacity: 0.7 }}>Doing footer</div>,
            items: [{ label: "Item C", id: 13 }],
        },
        {
            label: "Done",
            id: 3,
            items: [],
        },
    ]);

    // مثال: اینجا می‌تونی با info بفهمی چی جابه‌جا شده و ذخیره کنی
    const handleChange = (nextColumns, info) => {
        // ✅ 1) اعمال تغییرات در UI
        setCols(nextColumns);

        // ✅ 2) استفاده از info برای ذخیره / لاگ / ارسال به سرور
        console.log("Drag info:", info);

        // نمونه‌ی آماده برای API:
        // اگر آیتم جابه‌جا شد:
        if (info.active.type === "item") {
            const payload = {
                itemId: info.active.id,
                fromColumnId: info.from.columnId,
                fromIndex: info.from.index,
                toColumnId: info.to.columnId,
                toIndex: info.to.index,
            };
            console.log("Send to API payload:", payload);

            // مثلا:
            // api.updateItemPosition(payload)
        }

        // اگر ستون جابه‌جا شد:
        if (info.active.type === "column") {
            const payload = {
                columnId: info.active.id,
                fromIndex: info.from.index,
                toIndex: info.to.index,
            };
            console.log("Send to API payload:", payload);

            // مثلا:
            // api.updateColumnOrder(payload)
        }
    };

    return (
        <div className="h-full">
            <h3>Kanban Demo</h3>
            <div className="w-fit">
                <DndSortable
                    draggable={true}
                    draggableColumns={false}
                    draggableItems={true}
                    columns={cols}
                    columnClassName={(col) => `kanban-col kanban-col-${col.id} w-20rem p-2`}
                    onChange={(nextColumns, info) => {
                        setCols(nextColumns);
                        console.log(nextColumns);
                    }}
                />
            </div>
        </div>
    );
}



// import React, { useState } from "react";
// import {DndContext, closestCenter, PointerSensor, KeyboardSensor, useSensor, useSensors} from "@dnd-kit/core";
// import {SortableContext, useSortable, arrayMove, verticalListSortingStrategy, sortableKeyboardCoordinates, horizontalListSortingStrategy, rectSortingStrategy,} from "@dnd-kit/sortable";
// import { CSS } from "@dnd-kit/utilities";
//
// /* ---------- آیتم sortable ---------- */
// function SortableItem({ id, label }) {
//     const {setNodeRef, attributes, listeners, transform, transition, isDragging,} = useSortable({ id });
//
//     const style = {transform: CSS.Transform.toString(transform), transition, padding: "12px 14px", border: "1px solid #ddd", borderRadius: 8, background: isDragging ? "#fff" : "#fff", cursor: "grab", userSelect: "none",};
//
//     return (
//         <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
//             ⠿ {label}
//         </div>
//     );
// }
//
// /* ---------- کامپوننت اصلی ---------- */
// export default function Index() {
//     const [items, setItems] = useState([
//         { id: "1", label: "Task A" },
//         { id: "2", label: "Task B" },
//         { id: "3", label: "Task C" },
//         { id: "4", label: "Task D" },
//         { id: "5", label: "Task E" },
//         { id: "6", label: "Task F" },
//         { id: "7", label: "Task G" },
//         { id: "8", label: "Task H" },
//     ]);
//
//     const sensors = useSensors(
//         useSensor(PointerSensor, { activationConstraint: { distance: 5 } }),
//         useSensor(KeyboardSensor, {
//             coordinateGetter: sortableKeyboardCoordinates,
//         })
//     );
//
//     const handleDragEnd = (event) => {
//         const { active, over } = event;
//         if (!over || active.id === over.id) return;
//
//         setItems((prev) => {
//             const oldIndex = prev.findIndex((i) => i.id === active.id);
//             const newIndex = prev.findIndex((i) => i.id === over.id);
//             return arrayMove(prev, oldIndex, newIndex);
//         });
//     };
//
//     return (
//         <div style={{ maxWidth: 400, margin: "40px auto" }}>
//             <h3>Sortable List</h3>
//             <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
//                 <SortableContext items={items.map((i) => i.id)} strategy={rectSortingStrategy}>
//                     <div className="flex flex-wrap gap-3">
//                         {items.map((item) => (<SortableItem key={item.id} id={item.id} label={item.label}/>))}
//                     </div>
//                 </SortableContext>
//             </DndContext>
//             <pre style={{ marginTop: 16 }}>
//         {JSON.stringify(items, null, 2)}
//       </pre>
//         </div>
//     );
// }
